import { render } from "./HealthyRelationshipGuide.vue?vue&type=template&id=5c310bcc"
import script from "./HealthyRelationshipGuide.vue?vue&type=script&lang=js"
export * from "./HealthyRelationshipGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__